import Post from "../post/Post";
import "./posts.scss";
import { useQuery } from "react-query";

import api  from "../../services/api";

const retrievePosts = async () => {
  const res = await api.get("/api/osint/sample/posts/");
  return res.data;
};

const Posts = (props) => {
  const {
    data: posts,
    error,
    isLoading,
  } = useQuery("postsData", retrievePosts);

  if (isLoading) return <div>Fetching posts...</div>;
  if (error) return <div>An error occurred: {error.message}</div>;

  if (props.targetId) {
    console.log("Filtering");
    return (
      <div className="posts">
        {posts.map((post) => {
    	console.log("target");
          if (post.targetId === props.targetId) {
            return <Post post={post} key={post.id} />;
          }
        })}
      </div>
    );
  }

  if (props.caseId) {
    console.log("Filtering");
    return (
      <div className="posts">
        {posts.map((post) => {
    	console.log("case");
          if (post.caseId === props.caseId) {
            return <Post post={post} key={post.id} />;
          }
        })}
      </div>
    );
  }

  

  return (
    <div className="posts">
      {posts.map((post) => (
        <Post post={post} key={post.id} />
      ))}
    </div>
  );
};

export default Posts;
